import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const newsBlockFields = `
  _id,
  _type,
  title,
  backgroundColor,
  items[]{
    _type,
    title,
    body[],
    carouselImage {
      ${imageFields}
    },
    modalImage {
      ${imageFields}
    }
  }
`

export const NEWS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "news-block"][0]{
    ${newsBlockFields}
  }
`)
